import { ReactNode, useCallback, useState } from 'react';
// Types
import { ToolNameValue, ToolTypeValue } from 'app/store/pagesToolbar/pagesToolbar.types';
// Storage
import { getHiddenTools, onUpdateHiddenTools } from 'app/store/pagesToolbar/pagesToolbar.storage';
// Utils
import { PagesToolbarContext } from './utils/usePagesToolbarContext';
// 
import useGetTools from './utils/useGetTools';

type Props = {
  listRef?: any;
  pages?: any;
  toolType: ToolTypeValue;
  children: ReactNode;
}

const PagesToolbarContainer = ({ listRef, pages, toolType, children }:Props) => {
  const tools = useGetTools(toolType);

  // Hidden tools
  const [ hiddenTools, setHiddenTools ] = useState<ToolNameValue[]>(getHiddenTools(toolType));

  const handleUpdateHiddenTools = useCallback((toolName:ToolNameValue) => {
    setHiddenTools((prevState) => {
      const updateState = prevState.includes(toolName)
        ? prevState.filter((tool) => tool !== toolName)
        : [...prevState, toolName];
      onUpdateHiddenTools(toolType, updateState);
      return updateState;
    });
  }, [toolType, setHiddenTools]);

  return (
    <PagesToolbarContext.Provider value={{
      listRef,
      pages,
      tools,
      // Hidden tools
      hiddenTools,
      onUpdateHiddenTools: handleUpdateHiddenTools,
    }}>{children}</PagesToolbarContext.Provider>
  )
}

export default PagesToolbarContainer;
